import React from 'react';
import {r} from "@/utils/responsive";
import yamlAvatar from "@/assets/img/oracle_new_avatar.png";
import yamlCardBg from "@/assets/img/yaml_card_bg.png";
import bgCardVideo from "@/assets/video/bg_card_video.mp4";
import DisabledWrapper from "@/components/DisabledWrapper";
import {S3_FILES} from "@/config/s3_files";
import ReactPlayerWrapper from "@/components/ReactPlayerWrapper";

interface YamlOracleCardProps extends React.HTMLAttributes<HTMLDivElement> {
}

const YamlOracleCard: React.FC<YamlOracleCardProps> = ({className, ...props}) => {
    return (
        <div
            {...props}
            style={{
                position: "relative",
                width: r.vmax(939),
                height: r.vmax(461),
                padding: `${r.vmax(165)} ${r.vmax(72)} 0`,
                color: '#ffffff',
                fontSize: r.vmax(28),
                lineHeight: r.vmax(36),
                whiteSpace: 'pre-wrap',
                marginTop: r.vmax(63),
            }}
        >
            {/* Невидимый SVG с определением clipPath */}
            <svg style={{position: 'absolute', width: 0, height: 0}}>
                <defs>
                    <clipPath id="card_video_mask_yaml" clipPathUnits="objectBoundingBox">
                        <path
                            d="M1 0.266C1 0.184 1 0.143 0.988 0.118C0.975 0.092 0.955 0.092 0.914 0.092H0.872H0.814H0.214C0.199 0.092 0.192 0.092 0.185 0.087C0.178 0.083 0.172 0.073 0.161 0.054L0.151 0.038C0.140 0.019 0.134 0.010 0.127 0.005C0.120 0 0.113 0 0.098 0H0.085C0.045 0 0.025 0 0.0125 0.025C0 0.051 0 0.092 0 0.174V0.797C0 0.860 0 0.892 0.008 0.915C0.011 0.923 0.014 0.929 0.018 0.936C0.029 0.952 0.045 0.952 0.076 0.952C0.082 0.952 0.085 0.952 0.089 0.951C0.090 0.951 0.091 0.951 0.092 0.951C0.096 0.952 0.098 0.954 0.104 0.960L0.134 0.987C0.142 0.992 0.145 0.995 0.149 0.997C0.153 0.998 0.157 0.998 0.165 0.998H0.854C0.866 0.998 0.872 0.998 0.877 0.997C0.882 0.996 0.887 0.995 0.896 0.990L0.914 0.962C0.918 0.960 0.920 0.959 0.922 0.957C0.924 0.956 0.926 0.955 0.939 0.952C0.955 0.952 0.971 0.952 0.984 0.947C0.996 0.943 1 0.926 1 0.895L1 0.266Z"
                        />
                    </clipPath>
                </defs>
            </svg>
            <img style={{
                pointerEvents: 'none',
                position: 'absolute',
                zIndex: 2,
                left: r.vmax(-16),
                top: r.vmax(-83),
                width: r.vmax(276),
                height: r.vmax(284),
            }} alt="" src={S3_FILES.ORACLE_CARD_AVATAR}/>
            <div style={{
                position: 'relative',
                zIndex: 2,
                display: 'flex',
                flexDirection: 'column',
                gap: r.vmax(20),
                letterSpacing: r.vmax(-0.20),
            }}>
                <p>{`YAML Oracle — хранитель знаний и подсказок, её \nпророчества — документация Kubernetes, \nскрытая в недрах --help.`}</p>
                <p>{`Обращайтесь к ней, когда kubectl describe ничего \nне даёт. Она — ваш шепот разума в ночи деплоя.`}</p>
            </div>
            <DisabledWrapper>
                <img src={S3_FILES.ORACLE_CARD_BG} alt="" style={{
                    position: 'absolute',
                    inset: 0,
                    objectPosition: 'top',
                    objectFit: 'contain',
                    zIndex: 1,
                    opacity: .9
                }}/>

                <div style={{
                    position: 'absolute',
                    inset: 0,
                    clipPath: 'url(#card_video_mask_yaml)',
                }}>
                    <ReactPlayerWrapper videoSrc={S3_FILES.CHARACTER_CARD_BG_VIDEO}
                                        posterSrc={S3_FILES.CHARACTER_CARD_BG_VIDEO_POSTER} style={{
                        clipPath: 'url(#card_video_mask_yaml)',
                    }}/>
                </div>
            </DisabledWrapper>
        </div>
    );
};

export default YamlOracleCard;
